export const DEFAULT_TIME_ZONE = 'Asia/Tokyo';
export const REGEX_EMAIL =
  /^(?!.*\.\.)(?!.*\.@)(?![.])[a-zA-Z0-9._%+=/#!?|*^`{}"'$-]{1,64}@(?!-)[a-zA-Z0-9_-]+(?:\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,}$/;
export const RECENT_MODEL_FILES_NUMBER = 6;
export const MAX_SIZE_UPLOAD_FILE = 1024 * 1024 * 32; // 32MB
